module.exports = __webpack_public_path__ + "img/GAME_MULTI GOSTOP.c187c91b.png";